import _extends from '@babel/runtime/helpers/extends';
import React__default, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { useTaktId, createStormTaktId, RadioGroup, withTaktFallbackId, isMobileStyleMixin, RadioButton } from '@amzn/storm-ui';
import { u as useSearch } from '../../hooks/useSearch-D9iZPak2.js';
import { N as NoSearchResultsText } from './NoSearchResultsText-s1E5MS4q.js';
import { s as sanitizeCountries } from '../../utils/sanitizeCountries-erGcpLI_.js';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-BLE3wELi-CV9fXVbx.js';

const Container = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40018895__sc-pf33rm-0"
})(["padding:", " ", ";padding-block-start:", ";padding-block-end:", ";", ""], ({
  theme
}) => theme.spacing.small.default, ({
  theme
}) => theme.spacing.base.default, ({
  theme
}) => theme.spacing.small.default, ({
  theme
}) => theme.spacing.small.default, isMobileStyleMixin(css(["padding-block-end:", ";"], ({
  theme
}) => theme.spacing.base.mobile)));
const MultiSelectFilterContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40018895__sc-pf33rm-1"
})(["box-sizing:content-box;max-height:50vh;overflow-x:hidden;overflow-y:auto;", ""], isMobileStyleMixin(css(["max-height:86vh;"])));
const CountryRadioButton = withTaktFallbackId(RadioButton);
const CountryRadioGroup = ({
  id,
  onChange,
  selected,
  locale,
  taktId,
  taktValue
}) => {
  const {
    results: countries,
    exclude
  } = useSearch();
  const {
    formatMessage
  } = useIntl();
  const {
    getDataTaktAttributes
  } = useTaktId({
    taktId,
    fallbackId: createStormTaktId('country-selector-options')
  });
  const countryRadioButtons = useMemo(() => sanitizeCountries(countries).filter(country => !exclude.includes(country)).map(country => {
    let isChecked = false;
    if (selected === country) {
      isChecked = true;
    }
    return {
      name: country,
      label: `option-label-${country}`,
      isChecked,
      locale: country
    };
  }), [countries, exclude]);
  const handleChange = value => {
    const selectedCountry = countries.find(country => country === value);
    if (selectedCountry) {
      onChange === null || onChange === void 0 || onChange(selectedCountry);
    }
  };
  return /*#__PURE__*/React__default.createElement(MultiSelectFilterContainer, null, /*#__PURE__*/React__default.createElement(Container, null, countryRadioButtons.length > 0 && /*#__PURE__*/React__default.createElement(RadioGroup, {
    name: `${id}-select-list`,
    onChange: handleChange,
    label: formatMessage({
      id: 'single-country-group-label'
    }),
    hideLabel: true,
    selectedValue: selected
  }, countryRadioButtons.sort((countryA, countryB) => new Intl.Collator(locale, {
    caseFirst: 'upper'
  }).compare(formatMessage({
    id: countryA.label
  }) || countryA.name, formatMessage({
    id: countryB.label
  }) || countryB.name)).map(countryProps => {
    const {
      isChecked,
      name: countryName,
      label
    } = countryProps;
    return /*#__PURE__*/React__default.createElement(CountryRadioButton, _extends({}, getDataTaktAttributes({
      taktValue,
      taktIdSuffix: `${countryName}-option`
    }), {
      key: `${id}-${countryName}`,
      id: `${id}-${countryName}`,
      label: formatMessage({
        id: label
      }) || countryName,
      isChecked: isChecked,
      value: countryName,
      onChange: () => handleChange(countryName)
    }));
  })), !countries.length && /*#__PURE__*/React__default.createElement(NoSearchResultsText, null)));
};

export { CountryRadioGroup as C };
//# sourceMappingURL=CountryRadioGroup-DVnApD1J.js.map
